<template>

    <Page class="2xl:text-xl !max-w-[80%]">

        <h1 class="text-2xl mb-4 font-semibold">Where We're Heading</h1>

        <div class="flex flex-col gap-4 text-justify">
        
            <p>
                Our vision is to transform the automotive industry by giving every driver access to tailored, 
                convenient, and affordable automotive services, <span class="text-emerald-500 font-semibold">using cutting-edge telematics and mobile 
                technology</span> to deliver customized experiences that enhance safety, satisfaction, and long-term revenue.
            </p>

            <p class="list-item list-inside">
                New versions of <span class="text-emerald-500 font-semibold">Carbucks PROTECT</span> coming soon, e.g. electric vehicle option
            </p>

            <p class="list-item list-inside">
                New GFV product in flight called <span class="text-emerald-500 font-semibold">Carbucks GUARANTEE</span>
            </p>
                    
            <p class="list-item list-inside">
                International expansions <span class="text-emerald-500 font-semibold">NZ</span>, conversations in play with <span class="text-emerald-500 font-semibold">Singapore and UK</span>
            </p>

            <p class="list-item list-inside">
                New in-app purchasing and benefits, e.g. <span class="text-emerald-500 font-semibold">fuel deals</span>, <span class="text-emerald-500 font-semibold">MVI &amp; MyPlates</span>
            </p>

        </div>

    </Page>

</template>